import { useTypedApiClient } from 'hooks/useTypedApiClient'
import { type SystemBannerDTO } from 'types/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

interface UsePutRewardProps {
  id: number
  onSuccess?: (data: SystemBannerDTO, variables: SystemBannerDTO) => void
  onError?: (error: Error, variables: SystemBannerDTO) => void
}

export const usePutSystemBanner = ({
  id,
  onSuccess,
  onError,
}: UsePutRewardProps) => {
  const put = useTypedApiClient({
    path: '/admin/system-banners/{id}',
    method: 'put',
  })
  const queryClient = useQueryClient()

  return useMutation<any, Error, SystemBannerDTO>({
    mutationFn: async (data: SystemBannerDTO) => {
      const response = await put({ ...data, id })
      return response.data
    },
    onSuccess: async (data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: ['/admin/system-banners/{id}', id],
      })
      onSuccess?.(data, variables)
    },
    onError,
  })
}
